import $ from 'jquery';
export default function() {
    $('.toggle-group-button').each(function () {
        $(this).on('click', function() {
            const $id = $(this).data('toggleGroupId');
            if ($id === 'all') {
                $('.toggle-group-button').not(`[data-toggle-group-id="${$id}"]`).addClass('inactive');
                $(`.toggle-group-button[data-toggle-group-id="${$id}"]`).removeClass('inactive');
                $('.toggle-group').show();
            } else {
                $('.toggle-group-button').not(`[data-toggle-group-id="${$id}"]`).addClass('inactive');
                $(`.toggle-group-button[data-toggle-group-id="${$id}"]`).removeClass('inactive');
                $('.toggle-group').not(`[data-toggle-group-id="${$id}"]`).hide();
                $(`.toggle-group[data-toggle-group-id="${$id}"]`).show();
            }
        });
    });
}
